import { HomeUpcomingParRepays } from './HomeUpcomingParRepays';

export default HomeUpcomingParRepays;
